// Flujos de picking profesional para WMS

export const pickingFlows = [
  {
    key: 'picking',
    label: 'Picking',
    description: 'Picking guiado por orden de salida, producto y ubicación.'
  }
];

export const pickingFlowSchemas = {
  'picking': {
    name: 'Picking',
    steps: [
      { type: 'scan-orden-salida', label: 'Escanea la orden de salida', field: 'orden_salida', placeholder: 'Escanea o ingresa la orden de salida', validation: { required: true } },
      { type: 'resumen-orden-salida', label: 'Resumen de la orden', field: 'resumen_orden' }
      // El resto lo maneja el FlowRunner de forma dinámica
    ]
  }
}; 